var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Asignación de Esquema")])], 1),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", sm10: "", md10: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs5: "", sm5: "", md5: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.clientes.label,
                          items: _vm.clientesAll,
                          "item-text": _vm.formFields.clientes.formatItem,
                          "item-value": "id",
                          "data-vv-name": "selectedValue",
                          color: "primary",
                          clearable: true,
                          "no-data-text": "Sin resultados",
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.clientes.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.clientes, "value", $$v)
                          },
                          expression: "formFields.clientes.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md1: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-sm-center botones-filtros",
                        staticStyle: {
                          "padding-right": "20px",
                          "padding-left": "20px",
                          display: "block",
                          margin: "0 0 0 auto",
                          "margin-top": "15px"
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-icon", _vm._g({}, on), [
                                      _vm._v("report_problem")
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Si desea cambiar de cliente, seleccionelo de la lista y de\n                click a 'Filtrar'"
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.showTable } },
                          [
                            _c("v-icon", [_vm._v("search")]),
                            _vm._v("Filtrar ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.clearFilters } },
                          [
                            _c("v-icon", [_vm._v("clear")]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.showTables
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("div", { attrs: { id: "textEmpty" } }, [
              _vm._v("No ha seleccionado ningún cliente")
            ]),
            _c("img", { attrs: { src: require("@/assets/emptyIcon.png") } })
          ])
        : _vm._e(),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTables,
              expression: "showTables"
            }
          ],
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", {
            attrs: { xs12: "", sm12: "", md12: _vm.accionCrear.visible }
          }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: { color: "#ffe800" },
                      on: {
                        click: function($event) {
                          _vm.showModalAsignar = true
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "black" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("add_circle_outline")]
                      ),
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("Asignar Esquema")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTables,
              expression: "showTables"
            }
          ],
          staticClass: "gridcard rounded-card proveedores"
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", lg12: "", "d-flex": "" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.tablaDatos,
                      pagination: _vm.pagination,
                      "rows-per-page-items": _vm.rowsPerPage,
                      "group-by": "flotaId",
                      "rows-per-page-text": "Filas por página"
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.nombre_ws))
                            ]),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.integrador))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showModalAsignar
        ? _c("FormAsignarEsquema", {
            attrs: {
              asignarEsquema: _vm.asignarEsquema,
              usuarioActivo: _vm.usuarioActivo,
              clientesAll: _vm.clientesAll,
              clienteSession: _vm.formFields.clientes.value,
              clienteId: _vm.clienteId
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              },
              datoCreado: function($event) {
                return _vm.datoNuevo($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }